import styled from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
export const FAQContainerStyled = styled.div `
  padding: 48px;

  ${ADAPTIVE.maxWidth.tablet} {
    padding: 24px;
  }

  ${ADAPTIVE.maxWidth.mobile} {
    padding: 24px 16px;
  }

  background-color: ${colorCoreWhite1000};
`;
